/**
 * The LimoSphere app icon in its indigo colourway — the L and the sphere on the
 * navy tile — wherever the console names itself. The same drawing as
 * `public/favicon.svg`, inline so it is sharp at every size and costs no request.
 * Its colours are the brand's and deliberately not theme tokens: a logo that
 * followed `--accent` would be a different logo in dark mode.
 */
export function BrandMark({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 100 100" aria-hidden="true" focusable="false">
      <rect width="100" height="100" rx="22.4" fill="#141629" />
      <g transform="translate(19 19) scale(0.62)">
        <path
          d="M28 14H40A4 4 0 0 1 44 18V62H54A4 4 0 0 1 58 66V78A4 4 0 0 1 54 82H28A4 4 0 0 1 24 78V18A4 4 0 0 1 28 14Z"
          fill="#F4F5FF"
        />
        <circle cx="76" cy="72" r="11" fill="#6C7BFF" />
      </g>
    </svg>
  );
}
